(() => {
  const menu = document.getElementById('MobileMenu');
  const opener = document.querySelector('[data-menu-open]');
  let previousFocus;
  const closeMenu = () => { if (menu?.open) menu.close(); };
  opener?.addEventListener('click', () => {
    previousFocus = document.activeElement;
    menu.showModal();
    opener.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-is-open');
  });
  menu?.querySelector('[data-menu-close]')?.addEventListener('click', closeMenu);
  menu?.addEventListener('click', (event) => { if (event.target === menu) { const bounds = menu.getBoundingClientRect(); if (event.clientX > bounds.right || event.clientY > bounds.bottom || event.clientX < bounds.left) closeMenu(); } });
  menu?.addEventListener('close', () => { opener?.setAttribute('aria-expanded', 'false'); document.body.classList.remove('menu-is-open'); previousFocus?.focus(); });
  menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  function setupVideos(scope = document) {
    scope.querySelectorAll('[data-hero-media]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const video = root.querySelector('video');
      const button = root.querySelector('[data-video-toggle]');
      if (!video || !button) return;
      const update = () => { button.textContent = video.paused ? '▷' : 'Ⅱ'; button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel); };
      video.muted = true;
      video.playsInline = true;
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.autoplay = false; video.pause(); }
      else video.play().catch(update);
      button.addEventListener('click', () => video.paused ? video.play().catch(update) : video.pause());
      update();
    });
  }
  function setupVariants(scope = document) {
    scope.querySelectorAll('[data-product-root]').forEach(root => {
      const selector = root.querySelector('[data-variant-select]');
      if (!selector || selector.dataset.initialized) return;
      selector.dataset.initialized = 'true';
      selector.addEventListener('change', () => {
        const option = selector.selectedOptions[0];
        const price = root.querySelector('[data-variant-price]');
        const button = root.querySelector('[data-add-button]');
        const available = option.dataset.available === 'true';
        price.replaceChildren();
        const amount = document.createElement('span'); amount.textContent = option.dataset.price; price.append(amount);
        if (option.dataset.compare) { const compare = document.createElement('s'); compare.textContent = option.dataset.compare; price.append(compare); }
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        const quantity = root.querySelector('input[name="quantity"]');
        quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
        if (root.classList.contains('fgg-product')) root.dispatchEvent(new CustomEvent('fgg:variant', { detail: { media: option.dataset.media } }));
        else if (option.dataset.media) root.querySelector(`[id="ProductMedia-${option.dataset.media}"]`)?.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
  }
  setupVideos(); setupVariants();
  document.addEventListener('shopify:section:load', event => { setupVideos(event.target); setupVariants(event.target); });
})();
